import { useQuery } from "@tanstack/react-query";
import { PublicDiscount } from "~/api/models/DiscountCode";
import { useFetchAccessToken } from "~/api/salesForce/useFetchAccessToken";
import { QueryKeys } from "~/queryKeys";
import { salesforceServiceSingleton } from "~/services/salesForce/salesForce";
import { useLocaleStore } from "~/stores/locale/useLocaleStore";

export const useFetchPublicDiscounts = () => {
  const { locale } = useLocaleStore();
  const { data } = useFetchAccessToken();

  return useQuery({
    queryKey: [QueryKeys.useFetchPublicDiscounts, locale],
    queryFn: () =>
      salesforceServiceSingleton.getPublicDiscounts(
        data?.accessToken ?? "",
        locale
      ),
    enabled: !!data?.ensureAccessTokenIsValid?.(),
    select: (data) => data?.map((dto) => new PublicDiscount(dto)),
  });
};
